import React from "react";
import { ArrowRight, Truck } from "lucide-react";

const PRICING = [
  { medida: "90 × 190 cm",  pvp: 449, final: 349 },
  { medida: "90 × 200 cm",  pvp: 449, final: 349 },
  { medida: "105 × 190 cm", pvp: 529, final: 429 },
  { medida: "135 × 190 cm", pvp: 649, final: 549 },
  { medida: "135 × 200 cm", pvp: 649, final: 549 },
  { medida: "140 × 200 cm", pvp: 687, final: 587 },
  { medida: "150 × 190 cm", pvp: 687, final: 587 },
  { medida: "150 × 200 cm", pvp: 687, final: 587 },
  { medida: "160 × 200 cm", pvp: 814, final: 714 },
  { medida: "180 × 200 cm", pvp: 914, final: 814 },
  { medida: "200 × 200 cm", pvp: 949, final: 849 },
];

export default function PricingTable({ testidPrefix = "pricing" }) {
  return (
    <div className="mt-10 border border-[#E3DDE8] bg-white" data-testid={`${testidPrefix}-table`}>
      <div className="flex flex-wrap items-center justify-between gap-3 px-5 sm:px-6 py-4 border-b border-[#E3DDE8] bg-[#F9F8FA]">
        <div>
          <div className="font-display font-bold text-[#2E2638] text-lg leading-tight">Tarifa medidas estándar</div>
          <div className="text-xs text-[#5C5366]">Cheque de 100 € aplicado a cualquier medida</div>
        </div>
        <div className="flex items-center gap-2 text-xs text-[#5C5366]">
          <Truck size={14} className="text-[#8B1538]"/>
          <span>Entrega 2-5 días laborables</span>
        </div>
      </div>

      <div className="grid grid-cols-12 px-5 sm:px-6 py-3 text-[10px] uppercase tracking-[0.18em] font-bold text-[#5C5366] border-b border-[#E3DDE8]">
        <div className="col-span-6 sm:col-span-5">Medida</div>
        <div className="col-span-3 sm:col-span-4 text-right">Precio</div>
        <div className="col-span-3 text-right text-[#8B1538]">Con tu cheque</div>
      </div>

      <ul>
        {PRICING.map((row) => (
          <li key={row.medida} data-testid={`${testidPrefix}-row-${row.medida.replace(/ /g,'').replace(/×/g,'x')}`} className="grid grid-cols-12 items-center px-5 sm:px-6 py-3.5 border-b border-[#E3DDE8] last:border-b-0 hover:bg-[#F9F8FA] transition-colors">
            <div className="col-span-6 sm:col-span-5 text-[#2E2638] font-semibold text-sm sm:text-base">{row.medida}</div>
            <div className="col-span-3 sm:col-span-4 text-right text-[#B5AFBE] line-through text-sm">{row.pvp} €</div>
            <div className="col-span-3 text-right font-display font-bold text-[#8B1538] text-base sm:text-lg">{row.final} €</div>
          </li>
        ))}
      </ul>

      <div className="px-5 sm:px-6 py-4 border-t border-[#E3DDE8] bg-[#F9F0F3]/60 text-sm text-[#2E2638]">
        <strong>Medidas especiales (a medida):</strong> <span className="text-[#5C5366]">desde 67,5 × 180 hasta 200 × 200 cm. Plazo 10-15 días laborables. Pídenos el precio exacto con tu cheque.</span>
      </div>

      <a
        href="#hero-form"
        onClick={(e) => {
          e.preventDefault();
          const el = document.getElementById("hero-form");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
        data-testid={`${testidPrefix}-cta`}
        className="flex items-center justify-center gap-2 w-full px-6 py-4 bg-[#8B1538] hover:bg-[#6A0F2A] text-white font-bold uppercase tracking-wider text-xs sm:text-sm transition-colors"
      >
        Solicita tu cheque de 100 € <ArrowRight size={16}/>
      </a>
    </div>
  );
}
